import request from '@/utils/request'

let Project_investmentApi = {

  /*项目投资列表*/
  list(data) {
    return request._post('/shop/plus.project_investment.Index/index', data);
},
/*添加项目投资*/
add(data) {
    return request._post('/shop/plus.project_investment.Index/add', data);
},
/*修改项目投资*/
edit(data) {
    return request._post('/shop/plus.project_investment.Index/edit', data);
},
/*删除项目投资*/
del(data) {
    return request._post('/shop/plus.project_investment.Index/del', data);
},
/*项目投资详情*/
detail(data) {
  return request._post('/shop/plus.project_investment.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.project_investment.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.project_investment.Setting/getSetting', data, errorback);
    },
}
export default Project_investmentApi;



// WEBPACK FOOTER //
// ./src/api/project_investment.js